require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

var _objectWithoutProperties = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var visit = require("unist-util-visit");

var Typograf = require("typograf");

var escapeRegexp = require("lodash.escaperegexp");

function remarkTypograf() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var typograf = config.typograf,
      _config$builtIn = config.builtIn,
      builtIn = _config$builtIn === void 0 ? true : _config$builtIn,
      _config$keywords = config.keywords,
      keywords = _config$keywords === void 0 ? [] : _config$keywords,
      typografConfig = _objectWithoutProperties(config, ["typograf", "builtIn", "keywords"]);

  if (!typograf && builtIn === false) {
    throw new Error("Typograf option should be specified. Please pass instance typograf as option or set builtIn to true");
  }

  if (typograf && builtIn === true) {
    throw new Error("`builtIn` option is true and `typograf` also is passed. Please set `builtIn` to false or clean `typograf` option");
  }

  if (builtIn === true && typografConfig.locale && !Array.isArray(typografConfig.locale)) {
    throw new Error("Locale config should be array of string. e.g. {\"locale\": [\"ru\"]}");
  }

  if (builtIn === true && !Array.isArray(typografConfig && typografConfig.locale)) {
    typografConfig.locale = ["ru"];
  }

  if (!typograf) {
    typograf = new Typograf(typografConfig);
  }

  function getTextNodes(tree) {
    var textNodes = [];

    if (tree.type === "inlineCode") {
      textNodes.push("`" + tree.value + "`");
    }

    if (typeof tree.value === "string") {
      textNodes.push(tree.value);
    }

    visit(tree, "text", function (node) {
      textNodes.push(node.value);
    });
    return textNodes;
  }

  function getLeftSiblingText(index, children) {
    var textNodes = getTextNodes(children[index - 1]);
    return typograf.execute(textNodes.pop() || "");
  }

  function getRightSiblingText(index, children) {
    var textNodes = getTextNodes(children[index + 1]);
    return typograf.execute(textNodes.shift() || "");
  }

  function applyTypograf(text, index, parent) {
    if (index === 0 && parent.children.length > 1) {
      var rightText = getRightSiblingText(index, parent.children);
      var typografedText = typograf.execute(text + rightText);
      return typografedText.substring(0, typografedText.length - rightText.length);
    }

    if (index === parent.children.length - 1 && parent.children.length > 1) {
      var leftText = getLeftSiblingText(index, parent.children);

      var _typografedText = typograf.execute(leftText + text);

      return _typografedText.substring(leftText.length, _typografedText.length + leftText.length);
    }

    if (parent.children.length > 1) {
      var _leftText = getLeftSiblingText(index, parent.children);

      var _rightText = getRightSiblingText(index, parent.children);

      var _typografedText2 = typograf.execute(_leftText + text + _rightText);

      return _typografedText2.substring(_leftText.length, _typografedText2.length - _rightText.length);
    }

    return typograf.execute(text);
  }

  function visitor(node, index, parent) {
    var text = node.value;
    keywords.forEach(function (keyword) {
      var hex = Buffer.from(keyword).toString("hex");
      var regExp = new RegExp("".concat(escapeRegexp(keyword)), "g");
      text = text.replace(regExp, hex);
    });
    text = applyTypograf(text, index, parent);
    keywords.forEach(function (keyword) {
      var hex = Buffer.from(keyword).toString("hex");
      var regExp = new RegExp("".concat(escapeRegexp(hex)), "g");
      text = text.replace(regExp, keyword);
    });
    node.value = text;
  }

  function transform(tree) {
    visit(tree, "text", visitor);
  }

  return transform;
}

module.exports = {
  remarkTypograf: remarkTypograf
};